import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { createDeepSelectorRx, single } from "keautils";
import { filtrarUbicacionesPorColonias, esFiltroColoniaValido, obtenerDescripcionDireccion } from "./logic";
import { shallowEquals } from "keautils";
import { EstadoMunicipioCiudad } from "app/features/selectores/items/municipio/index";
import { Colonias } from "app/features/selectores/simples";
import { observeResource } from "kea-resource";
import { EstadoMunicipioCiudadValue } from "app/features/selectores";

const createShallowSelector = createDeepSelectorRx;

export interface Props {
    value?: number | null;
    onChange?: (value: number | null | undefined) => PromiseLike<void>;
    listas?: models.Ubicaciones;
    label?: string;
    iconClass?: string;
    readonly?: boolean;
    error?: kea.FieldError;
}

interface EstadoMunicipioCiudad {
    estado?: number | null;
    municipio?: number | null;
    ciudad?: number | null;
}
interface State {
    estadomunicipioCiudad: EstadoMunicipioCiudad;
    codigoPostal?: number;
}

/**
* Componente para seleccionar una colonia
*/
export class ColoniaComponentNoRx extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = { estadomunicipioCiudad: {} };
    }

    private getField = kea.formfields(() => this.props);

    private value = (state: State, props: Props) => props.value;
    private idColonia = (state: State, props: Props) => props.value;
    private colonia = createSelectorRx(this.idColonia, async (id) => {
        if (id != null) {
            var colonia = await resources.Colonia.get(id);
            this.setState({ codigoPostal: colonia && colonia.CodigoPostal });
            return colonia;
        } else {
            if (id === null)
                this.setState({ codigoPostal: undefined });
            return id;
        }
    });

    private ubicaciones = (state: State, props: Props) => props.listas!;
    //Ciudad municipio 
    private ciudadMunicipioFromColonia = createSelectorRx(this.colonia, async x => {
        const y = await x;
        return (
            y == null ? y :
                { municipio: y.IdMunicipio, ciudad: y.IdCiudad, estado: y.IdEstado }
        );
    });
    private ciudadMunicipioFromState = (state: State, props: Props) => state.estadomunicipioCiudad;
    private ciudadMunicipio = createSelectorRx(this.ciudadMunicipioFromColonia, this.ciudadMunicipioFromState, (col, fromSt) => {
        const ret = col === null ? { ciudad: null, estado: null, municipio: null } : { ...fromSt, ...col };
        return ret;
    });

    //Codigo postal
    private codigoPostalFromColonia = createSelectorRx(this.colonia, async x => {
        const y = await x;
        return y && y.CodigoPostal;
    });
    private codigoPostalFromState = (state: State, props: Props) => state.codigoPostal;
    private codigoPostal = createSelectorRx(this.codigoPostalFromColonia, this.codigoPostalFromState, (col, fromSt) => {
        return col === null ? null : (col || fromSt);
    });


    private filtroColonia = createSelectorRx(this.codigoPostal, this.ciudadMunicipio,
        async (promCp, promCiudadMun) => {
            const cp = await promCp;
            const ciudadMun = await promCiudadMun;
            //Note que no estamos incluyendo el estado en el filtro de colonias, esto por que si al seleccionar un estado llenammos el listado de colonais, seran demasiadas
            const ret: models.FiltroColonia = {
                CodigoPostal: cp,
                IdMunicipio: ciudadMun.municipio,
                IdCiudad: ciudadMun.ciudad,
            };

            return ret;
        });

    private filtroColoniaVaido = createSelectorRx(this.filtroColonia, async (filtro) => esFiltroColoniaValido(await filtro));

    /**Listado de colonias que se debe de mostrar o indefinido si el filtro de colonias es invalido */
    private colonias = createSelectorRx(this.filtroColonia, this.filtroColoniaVaido, async (filtro, filtroValido) => {
        if (await filtroValido) {
            const f = await filtro;
            const ret = await resources.Colonia.query(f);
            return ret;
        } else {
            return [];
        }
    });

    /**Ubicaciones filtradas por las colonias */
    private ubicacionesFiltradas = createSelectorRx(this.colonias, this.filtroColoniaVaido, this.ubicaciones, async (promColonias, promFiltroValido, ubicaciones) => {
        if (await promFiltroValido) {
            const colonias = await promColonias;
            return filtrarUbicacionesPorColonias(ubicaciones, colonias);
        } else {
            return ubicaciones;
        }
    });

    private onColoniaChange = async (id: number) => {
        if (this.props.onChange)
            await this.props.onChange(id);
    }

    private onCodigoPostalChange = async (CP: number | undefined | null) => {
        //Al cambiar el codigo postal se establecen todos los valores, excepto la colonia
        //Cambiamos el CP, pero todavia falta calcular las sugerencias
        this.setState({ codigoPostal: CP || undefined });

        const colonias = await resources.Colonia.query({ CodigoPostal: CP });
        if (colonias.length > 0) {
            const col: models.ColoniaDTO | undefined = colonias[0];
            this.setState({ estadomunicipioCiudad: { estado: col.IdEstado, municipio: col.IdMunicipio, ciudad: col.IdCiudad || undefined } });

            const singleCol = single(colonias);
            if (this.props.onChange) {
                await this.props.onChange(singleCol && singleCol.IdRegistro);
            }

        }
    }

    private onEstadoMunicipioCiudadChange = (x: EstadoMunicipioCiudadValue) => {
        this.setState({ estadomunicipioCiudad: x });

        if (this.props.onChange)
            this.props.onChange(undefined);
    }

    render() {
        const ciudadMun = this.ciudadMunicipio(this.state, this.props);
        const codPostal = this.codigoPostal(this.state, this.props);
        const colonias = this.colonias(this.state, this.props);
        const ubicaciones = this.ubicacionesFiltradas(this.state, this.props);

        const { value, readonly, label, iconClass, error } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);

        const body =
            <div>
                {kea.autogrid(6, [
                    <kea.Number value={this.state.codigoPostal ? this.state.codigoPostal : codPostal} onChange={this.onCodigoPostalChange} label="Código postal" readonly={readonly} />,
                    <Colonias items={colonias} value={value} onChange={this.onColoniaChange} readonly={readonly} error={error} label="Colonia" />
                ])}

                {kea.autogrid(12, [
                    <EstadoMunicipioCiudad value={ciudadMun} onChange={this.onEstadoMunicipioCiudadChange} listas={ubicaciones} readonly={readonly} />
                ])}
            </div>;
        return (
            (label || iconClass) ?
                <kea.Panel title={label} iconClass={iconClass}>
                    {body}
                </kea.Panel> : body
        );
    }
}

export const ColoniaComponent = kea.defaultProps(componentToRx(ColoniaComponentNoRx as React.ComponentClass<Props>), { listas: resources.UbicacionesRx });


// WEBPACK FOOTER //
// ./app/features/componentes/direccion/colonia.tsx